import { NavLink, useLocation } from "react-router-dom";
import { Home, MapPin, MessageCircle, Phone } from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  { icon: Home, label: "Home", to: "/" },
  { icon: MapPin, label: "Destinations", to: "/destinations" },
  { 
    icon: MessageCircle, 
    label: "WhatsApp", 
    to: `https://wa.me/917490019959?text=${encodeURIComponent("Hello Feel Free Holidays, I'm interested in planning a trip.")}`,
    external: true 
  },
  { icon: Phone, label: "Contact", to: "/contact" },
];

export const MobileBottomNav = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border md:hidden pb-safe">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = !item.external && location.pathname === item.to;
          const isWhatsApp = item.label === "WhatsApp";

          if (item.external) {
            return (
              <a
                key={item.label}
                href={item.to}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center gap-1 flex-1 py-2 text-green-800"
              >
                <div className="relative">
                  <item.icon className="h-5 w-5" />
                  <span className="absolute -top-1 -right-1 w-2 h-2 bg-green-500 rounded-full animate-pulse" />
                </div>
                <span className="text-[10px] font-medium">{item.label}</span>
              </a>
            );
          }

          return (
            <NavLink
              key={item.label}
              to={item.to}
              className={cn(
                "flex flex-col items-center justify-center gap-1 flex-1 py-2 transition-colors",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <item.icon className={cn("h-5 w-5", isActive && "fill-primary/20")} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
